import { trpc } from "../../../trpc"
import { AnalyticsQueryArgs } from "../Analytics"
import { BaseGraph } from "./Base"
import { getSubTime } from "./getSubTime"

const format = (num: number | undefined) => {
  if (typeof num === "undefined") {
    return "0 ms"
  }
  return `${num.toFixed(1)} ms`
}

const formatYTicks = (num: number | undefined) => {
  if (typeof num === "undefined") {
    return "0 ms"
  }
  return `${num.toFixed(0)} ms`
}

export const KeyframeDeltaGraph = (props: AnalyticsQueryArgs) => {
  const { from, to } = props.time
  const subTime = getSubTime(props.time)

  const { data: viewers, isFetching } = trpc.analytics.keyframeDeltaAvgRange.useQuery(
    { ...props, mediaType: "video" },
    {
      keepPreviousData: true,
    }
  )
  const { data: prevViewers, isFetching: subIsFetching } = trpc.analytics.keyframeDeltaAvgRange.useQuery(
    { ...props, time: subTime, mediaType: "video" },
    { keepPreviousData: true }
  )

  const mainData = viewers?.[0]?.points || []
  const subData = prevViewers?.[0]?.points || []

  return (
    <BaseGraph
      mainData={mainData}
      subData={subData}
      splitValues={[0]}
      title="Time between video keyframes"
      mainDescription="Delta this period"
      subDescription="Delta previous period"
      info={"Typically configured to 1 or 2 seconds"}
      time={{ from, to, subFrom: subTime.from, subTo: subTime.to }}
      formatValue={format}
      formatYTicks={formatYTicks}
      isLoading={isFetching || subIsFetching}
    />
  )
}
